import LoveCanalData from "../../../../src/components/love-canal-data.js";
import * as React from 'react';
export default {
  LoveCanalData,
  React
};